import React from "react";
import styles from "./MaxWidthContainer.module.scss";
import classnames from "classnames";

interface MaxWidthContainerProps {
  children: React.ReactNode;
  className?: string;
}

export default function MaxWidthContainer({
  children,
  className,
}: MaxWidthContainerProps): React.JSX.Element {
  return (
    <div className={classnames(styles.root, className)}>
      <div className={styles.maxWidthContent}>{children}</div>
    </div>
  );
}
